import React, { useState, useEffect } from 'react'
import { getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import InfoModal from '../../components/InfoModal';
import CreateMissionAI from '../CreateMissionAI';
import { dateToDatetimeLocal } from './utils';

const MissionsTab = ({ missions, setMissions, missionStartTime, setMissionStartTime, startTime, gameId, gameLocation, gameConcepts, name, triggerAutoSave, setError }) => {
    // Firebase Storage インスタンス
    const storage = getStorage();

    //ミッション
    const [missionName, setMissionName] = useState("");
    const [missionScore, setMissionScore] = useState(0);
    const [missionScoreNoSubmit, setMissionScoreNoSubmit] = useState(0);
    const [missionEndTime, setMissionEndTime] = useState("");
    const [missionDetail, setMissionDetail] = useState("");
    const [missionOptions, setMissionOptions] = useState([false, false, false, false, false, false, false]);
    const [missionRepeatInterval, setMissionRepeatInterval] = useState(30);
    const [focusMission, setFocusMission] = useState(null);
    const [startNext, setStartNext] = useState(null);
    const [missionQrCode, setMissionQrCode] = useState("");
    const [missionImage, setMissionImage] = useState("");
    const [missionImageUploading, setMissionImageUploading] = useState(false);
    const [missionImageValue, setMissionImageValue] = useState("");

    //AIでミッションを生成
    const [showAIModal, setShowAIModal] = useState(false);

    //ミッションを追加
    const addMission = () => {
        // タイトルの文字数チェック
        if (!missionName || missionName.trim().length === 0) {
            setError("ミッションのタイトルを入力してください");
            return;
        }

        if (missionName.length > 30) {
            setError("ミッションのタイトルは30文字以内で入力してください");
            return;
        }

        const newMission = {
            name: missionName,
            score: Number(missionScore),
            time: {
                start: missionStartTime,
                end: Number(missionEndTime),
                startNext: startNext
            },
            detail: missionDetail,
            options: missionOptions,
            repeatInterval: Number(missionRepeatInterval),
            penalty: Number(missionScoreNoSubmit),
            qrCode: missionQrCode,
            image: missionImage || null
        }

        if(focusMission !== null) {
            setMissions((prev) => {
                const newMissions = [...prev];
                newMissions[focusMission] = newMission;
                return newMissions;
            });
        } else {
            setMissions((prev) => [
                ...prev,
                newMission
            ])
        }

        triggerAutoSave();


        setMissionName("");
        setMissionScore(0);
        setMissionStartTime(startTime ? dateToDatetimeLocal(new Date(startTime)) : "");
        setMissionEndTime("");
        setMissionDetail("");
        setMissionImage("");
        setFocusMission(null);
        setMissionOptions([false, false, false, false, false, false, false]);
        setMissionRepeatInterval(30);
        setMissionScoreNoSubmit(0);
        setMissionQrCode("");

        console.log(missions)
    }

    //ミッションを削除
    const deleteMission = (index) => {
        setFocusMission(null);
        setMissions((prev) => {
            return prev.filter((mission, i) => i !== index)
        })
        triggerAutoSave();
    }

    //ミッションを編集
    // missions/startTimeをここで依存に含めると、他の変更による更新のたびに編集中のフォームが上書きされてしまうため、
    // focusMissionが変化した時のみ発火させる意図的な設計とする。
    useEffect(() => {
        if(focusMission !== null) {
            setMissionName(missions[focusMission].name);
            setMissionScore(missions[focusMission].score);
            setMissionStartTime(missions[focusMission].time.start);
            setMissionEndTime(missions[focusMission].time.end);
            setMissionDetail(missions[focusMission].detail);
            setMissionImage(missions[focusMission].image ? missions[focusMission].image : "");
            setMissionOptions(missions[focusMission].options ? missions[focusMission].options : [false, false, false, false, false, false, false]);
            setMissionRepeatInterval(missions[focusMission].repeatInterval ? missions[focusMission].repeatInterval : 30);
            setMissionScoreNoSubmit(missions[focusMission].penalty ? missions[focusMission].penalty : 0);
            setStartNext(missions[focusMission].time.startNext ? missions[focusMission].time.startNext : null);
            setMissionQrCode(missions[focusMission].qrCode ? missions[focusMission].qrCode : "");
        } else {
            setMissionName("");
            setMissionScore(0);
            setMissionStartTime(startTime ? dateToDatetimeLocal(new Date(startTime)) : "");
            setMissionEndTime("");
            setMissionDetail("");
            setMissionImage("");
            setMissionOptions([false, false, false, false, false, false, false]);
            setMissionRepeatInterval(30);
            setMissionScoreNoSubmit(0);
            setStartNext(null);
            setMissionQrCode("");
            setMissionImageValue("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusMission]);

    // ミッションのオプション選択を変更
    const changeMissionOptionsSelect = (e, index) => {
        const newOptions = [...missionOptions];
        newOptions[index] = e.target.checked;
        setMissionOptions(newOptions);
    }

    // CSVファイルを解析してミッションデータをインポートする
    const importMissionsCsv = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const csv = e.target.result;
                const lines = csv.split('\n').filter(line => line.trim() !== '');
                const newMissions = [];

                lines.forEach((line, index) => {
                    const columns = line.split(',').map(col => col.trim());

                    if (columns.length < 1) {
                        alert(`行 ${index + 1}: データが不足しています（最低1列必要）`);
                        return;
                    }

                    const missionName = columns[0];
                    const scoreText = columns[1] || '0';
                    const penaltyText = columns[2] || '0';
                    const startTimeText = columns[3] || '';
                    const endTimeText = columns[4] || '';
                    const detail = columns[5] || '';
                    const option1 = columns[6] === 'TRUE' || columns[6] === 'true';
                    const option2 = columns[7] === 'TRUE' || columns[7] === 'true';
                    const option3 = columns[8] === 'TRUE' || columns[8] === 'true';
                    const option4 = columns[9] === 'TRUE' || columns[9] === 'true';
                    const option5 = columns[10] === 'TRUE' || columns[10] === 'true';
                    const option6 = columns[11] === 'TRUE' || columns[11] === 'true';
                    const option7 = columns[12] === 'TRUE' || columns[12] === 'true';
                    const repeatIntervalText = columns[13] || '30';
                    const qrCode = columns[14] || '';
                    const image = columns[15] || '';

                    // バリデーション
                    if (!missionName || missionName.trim() === '') {
                        alert(`行 ${index + 1}: ミッション名が空です`);
                        return;
                    }

                    if (missionName.length > 30) {
                        alert(`行 ${index + 1}: ミッション名は30文字以内で入力してください`);
                        return;
                    }

                    // スコアの変換
                    const score = parseInt(scoreText);
                    if (isNaN(score)) {
                        alert(`行 ${index + 1}: スコアは数値で入力してください`);
                        return;
                    }

                    // ペナルティの変換
                    const penalty = parseInt(penaltyText);
                    if (isNaN(penalty)) {
                        alert(`行 ${index + 1}: ノーサブミットペナルティは数値で入力してください`);
                        return;
                    }

                    // リピート間隔の変換
                    const repeatInterval = parseInt(repeatIntervalText);
                    if (isNaN(repeatInterval) || repeatInterval < 1) {
                        alert(`行 ${index + 1}: リピート間隔は1以上の数値で入力してください`);
                        return;
                    }

                    newMissions.push({
                        name: missionName.trim(),
                        score: score,
                        time: {
                            start: startTimeText.trim(),
                            end: endTimeText.trim(),
                            startNext: null
                        },
                        detail: detail.trim(),
                        options: [option1, option2, option3, option4, option5, option6, option7],
                        repeatInterval: repeatInterval,
                        penalty: penalty,
                        qrCode: qrCode.trim(),
                        image: image.trim() || null
                    });
                });

                if (newMissions.length > 0) {
                    setMissions(prev => [...prev, ...newMissions]);
                    triggerAutoSave();
                    alert(`${newMissions.length}個のミッションをインポートしました`);
                }
            } catch (error) {
                alert('CSVファイルの読み込みに失敗しました: ' + error.message);
            }
        };
        reader.readAsText(file);
    };

    // ミッションCSVファイルハンドラー
    const handleMissionCsvImport = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!file.name.toLowerCase().endsWith('.csv')) {
            alert('CSVファイルを選択してください');
            return;
        }

        importMissionsCsv(file);
        // ファイル入力をリセット
        event.target.value = '';
    };

    // ミッションリストをCSV形式でエクスポートする
    const exportMissionsCsv = () => {
        try {
            // CSVヘッダー
            const csvHeader = 'ミッション名,スコア,ノーサブミットペナルティ,開始時刻,制限時間(分),詳細,オプション1,オプション2,オプション3,オプション4,オプション5,オプション6,オプション7,リピート間隔(分),QRコード,画像URL\n';

            // ミッションデータをCSV形式に変換
            const csvData = missions.map(mission => {
                const missionName = mission.name || '';
                const score = mission.score || 0;
                const penalty = mission.penalty || 0;
                const startTime = mission.time?.start || '';
                const endTime = mission.time?.end || '';
                const detail = mission.detail || '';
                const options = mission.options || [false, false, false, false, false, false, false];
                const repeatInterval = mission.repeatInterval || 30;
                const qrCode = mission.qrCode || '';
                const image = mission.image || '';

                // CSVフィールドをエスケープ（カンマや改行が含まれる場合はダブルクォートで囲む）
                const escapeField = (field) => {
                    const fieldStr = String(field);
                    if (fieldStr.includes(',') || fieldStr.includes('\n') || fieldStr.includes('"')) {
                        return '"' + fieldStr.replace(/"/g, '""') + '"';
                    }
                    return fieldStr;
                };

                return [
                    escapeField(missionName),
                    escapeField(score),
                    escapeField(penalty),
                    escapeField(startTime),
                    escapeField(endTime),
                    escapeField(detail),
                    escapeField(options[0] ? 'TRUE' : 'FALSE'),
                    escapeField(options[1] ? 'TRUE' : 'FALSE'),
                    escapeField(options[2] ? 'TRUE' : 'FALSE'),
                    escapeField(options[3] ? 'TRUE' : 'FALSE'),
                    escapeField(options[4] ? 'TRUE' : 'FALSE'),
                    escapeField(options[5] ? 'TRUE' : 'FALSE'),
                    escapeField(options[6] ? 'TRUE' : 'FALSE'),
                    escapeField(repeatInterval),
                    escapeField(qrCode),
                    escapeField(image)
                ].join(',');
            }).join('\n');

            // CSV全体のデータ
            const csvContent = csvHeader + csvData;

            // BOM付きUTF-8でエンコード（Excelで文字化けしないように）
            const bom = '﻿';
            const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });

            // ダウンロード用のリンクを作成
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `ミッションリスト_${name || 'ゲーム'}_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            console.log(`${missions.length}個のミッションデータをCSVエクスポートしました`);
            alert('ミッションリストをCSVファイルでダウンロードしました');
        } catch (error) {
            console.error('CSV export error:', error);
            alert('CSVファイルの出力でエラーが発生しました');
        }
    };

    // 画像リサイズ関数
    const resizeImage = (file, maxWidth = 800, maxHeight = 800, quality = 0.8) => {
        return new Promise((resolve) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = new Image();

            img.onload = () => {
                // アスペクト比を保持しながらリサイズ
                let { width, height } = img;

                if (width > height) {
                    if (width > maxWidth) {
                        height = height * (maxWidth / width);
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = width * (maxHeight / height);
                        height = maxHeight;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                // 画像を描画
                ctx.drawImage(img, 0, 0, width, height);

                // Blobとして出力
                canvas.toBlob(resolve, 'image/jpeg', quality);
            };

            img.src = URL.createObjectURL(file);
        });
    };

    // ミッション画像のアップロード
    const handleMissionImageUpload = async (file) => {
        if (!file) return;

        // 画像ファイルかチェック
        if (!file.type.startsWith('image/')) {
            setError('画像ファイルを選択してください');
            return;
        }

        // ファイルサイズチェック（5MB制限）
        if (file.size > 5 * 1024 * 1024) {
            setError('画像ファイルは5MB以下にしてください');
            return;
        }

        setMissionImageUploading(true);
        setError(null);

        try {
            // 画像をリサイズ
            const resizedFile = await resizeImage(file);

            // ファイル名を生成（ゲームID + ミッション番号 + タイムスタンプ）
            const timestamp = Date.now();
            const fileName = `mission_${gameId}_${missions.length}_${timestamp}.jpg`;
            const imageRef = storageRef(storage, `missions/${gameId}/${fileName}`);

            // アップロード開始（リサイズした画像を使用）
            const uploadTask = uploadBytesResumable(imageRef, resizedFile);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    // 進捗表示（必要に応じて）
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('アップロード進捗:', progress + '%');
                },
                (error) => {
                    console.error('アップロードエラー:', error);
                    setError('画像のアップロードに失敗しました');
                    setMissionImageUploading(false);
                },
                async () => {
                    // アップロード完了
                    try {
                        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                        setMissionImage(downloadURL);
                        setMissionImageUploading(false);
                        console.log('画像アップロード完了:', downloadURL);
                    } catch (error) {
                        console.error('ダウンロードURL取得エラー:', error);
                        setError('画像URLの取得に失敗しました');
                        setMissionImageUploading(false);
                    }
                }
            );
        } catch (error) {
            console.error('画像アップロードエラー:', error);
            setError('画像のアップロードに失敗しました');
            setMissionImageUploading(false);
        }
    };

    // ミッション画像を削除
    const handleMissionImageDelete = async () => {
        if (!missionImage) return;

        const result = window.confirm('画像を削除しますか？');
        if (!result) return;

        try {
            // Firebase StorageのURLから画像パスを抽出して削除
            if (missionImage.includes('firebase')) {
                // URLから画像パスを抽出
                const url = new URL(missionImage);
                const fullPath = decodeURIComponent(url.pathname.split('/o/')[1].split('?')[0]);
                const imageRef = storageRef(storage, fullPath);

                // Firebase Storageから削除
                await deleteObject(imageRef);
                console.log('Firebase Storageから画像を削除しました');
            }
        } catch (error) {
            console.error('画像削除エラー:', error);
            // Firebase Storageでの削除に失敗してもUIの画像は削除する
        }

        // UIから画像を削除
        setMissionImage("");
        setMissionImageValue("");
    };

    // AI生成されたミッションデータを受け取る
    const handleAIGeneratedMission = (missionData) => {
        setMissionName(missionData.name);
        setMissionDetail(missionData.detail);
        setMissionScore(missionData.score);
        setMissionScoreNoSubmit(missionData.penalty);
        setMissionOptions(missionData.options);
        setMissionQrCode(missionData.qrCode || '');
    };

    return (
        <div className='mx-3'>
            {/* ミッション管理ヘッダー */}
            <div className='rounded-lg bg-white p-3 mb-3 shadow-sm'>
                <h3 className='text-lg text-gray-800 mb-1'>ミッション管理</h3>
                <p className='text-sm ms-2 text-gray-600'>
                    ミッション情報を管理してください。<br/>
                    <strong>CSV形式:</strong> ミッション名,スコア,ノーサブミットペナルティ,開始時刻,終了時刻,詳細,オプション1-7(TRUE/FALSE),リピート間隔(分),QRコード,画像URL
                </p>
                <div className='flex gap-2 mt-3'>
                    <label className='border border-green-500 text-green-500 px-3 py-1 rounded text-sm hover:bg-green-50 cursor-pointer'>
                        <i className='bi bi-file-earmark-arrow-up me-1'></i>CSV インポート
                        <input
                            type="file"
                            accept=".csv"
                            onChange={handleMissionCsvImport}
                            className="hidden"
                        />
                    </label>
                    <button
                        onClick={exportMissionsCsv}
                        className='border border-blue-500 text-blue-500 px-3 py-1 rounded text-sm hover:bg-blue-50'
                        disabled={!missions || missions.length === 0}
                    >
                        <i className='bi bi-file-earmark-arrow-down me-1'></i>CSV エクスポート
                    </button>
                </div>
            </div>

            <div className='lg:grid lg:grid-cols-2'>
                <div className='mb-6 mx-3'>
                    <h2 className='mb-3 text-center text-gray-600'>ミッション一覧 {missions && missions.length}</h2>
                    {
                        // ミッションを発令時刻順にソートして表示
                        missions && missions.map((mission, index) => ({...mission, index: index})).sort((a, b) => new Date(a.time?.start).getTime() - new Date(b.time?.start).getTime()).map((mission, index) => {
                            return (
                                <div key={mission.index} className={'rounded-lg bg-white p-4 mb-3 relative cursor-pointer ' + (focusMission === mission.index ? 'border border-purple-500 shadow' : 'shadow-sm')} onClick={() => setFocusMission(mission.index)}>
                                    <div className='text-lg tracking-widest mb-1'><i className='bi bi-clipboard-check me-1 text-purple-500'></i>{mission.name}</div>
                                    <div className='text-sm text-gray-600'><i className='bi bi-clock me-1'></i>{new Date(mission.time.start).toLocaleString()} / {mission.time.end}分間</div>
                                </div>
                            )
                        })
                    }
                    <div className='rounded-lg bg-purple-500 px-4 py-3 mt-6 shadow-sm mb-3 relative cursor-pointer hover:bg-purple-600' onClick={() => setFocusMission(null)}>
                        <div className='text-lg tracking-widest text-white text-center '><i className='bi bi-plus-lg me-2 '></i>ミッションを追加</div>
                    </div>
                </div>

                <div className='mb-6 mx-3 bg-white border rounded-lg p-3 pt-6 shadow-sm relative'>
                    {/* AIで生成 */}
                    <button className='rounded-md border py-1 px-2 absolute top-2 end-5 text-sm text-gray-600 hover:bg-gray-50' onClick={() => setShowAIModal(true)}>
                        <i className='bi bi-stars text-lime-500 me-1'></i>AIで生成
                    </button>

                    {/* ミッション情報の編集 */}
                    <div className='mb-4 mx-2'>
                        <label>タイトル</label>
                        <input
                            value={missionName}
                            onChange={(e) => setMissionName(e.target.value)}
                            type="text"
                            maxLength={30}
                            className={`w-full p-2 border rounded-lg mb-2 focus:outline-purple-300 ${
                                missionName.length > 30 ? 'border-red-500' : ''
                            }`}
                        />
                        {missionName.length > 30 && (
                            <p className="text-red-500 text-sm mt-1">タイトルは30文字以内で入力してください</p>
                        )}
                    </div>

                    <h3 className='mb-1 mx-2'>時刻</h3>
                    <div className='lg:grid lg:grid-cols-2'>
                        <div className='mb-4 mx-2'>
                            <label>開始時刻</label>
                            <input value={missionStartTime} onChange={(e) => setMissionStartTime(e.target.value)} type="datetime-local" className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                        </div>
                        <div className='mb-4 mx-2'>
                            <label>制限時間 [分]</label>
                            <input value={missionEndTime} onChange={(e) => setMissionEndTime(e.target.value)} type="number" className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                        </div>
                    </div>

                    <div className='lg:grid lg:grid-cols-2'>
                        <div className='mb-4 mx-2 mt-3'>
                            <label>報酬スコア</label>
                            <input value={missionScore} onChange={(e) => setMissionScore(e.target.value)} type="number" placeholder='0' className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                        </div>

                        <div className='mb-4 mx-2'>
                            <label>未達成時の減点スコア
                                <InfoModal>
                                    <p>時間内に提出しなかった場合に減点されるスコアを設定します。<br />逆に、スコアを加算する場合は、負の値を入力します。</p>
                                    <p className='text-gray-700 my-3'>例 : 未達成のチームに50pt減点する場合、<strong>50</strong>を入力。</p>
                                </InfoModal>
                            </label>
                            <input value={missionScoreNoSubmit} onChange={(e) => setMissionScoreNoSubmit(e.target.value)} type="number" placeholder='0' className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                        </div>
                    </div>

                    <div className='mb-3 mx-2'>
                        <label>詳細</label>
                        <textarea value={missionDetail} onChange={(e) => setMissionDetail(e.target.value)} className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" rows="4"></textarea>
                    </div>

                    <div className='mb-3 mx-2'>
                        <label>画像</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => {setMissionImageValue(e.target.value); handleMissionImageUpload(e.target.files[0]);}}
                            className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300"
                            disabled={missionImageUploading || missionImage}
                            value={missionImageValue}
                        />
                        {missionImageUploading && (
                            <div className="text-blue-600 text-sm mt-1">
                                <i className="bi bi-upload me-1"></i>アップロード中...
                            </div>
                        )}
                        {missionImage && (
                            <div className="mt-2">
                                <img
                                    src={missionImage}
                                    alt="ミッション画像"
                                    className="max-w-full h-32 object-contain border rounded"
                                />
                                <button
                                    type="button"
                                    className="block mt-1 text-red-600 text-sm hover:underline"
                                    onClick={handleMissionImageDelete}
                                >
                                    画像を削除
                                </button>
                            </div>
                        )}
                    </div>

                    <div className='mb-6 mx-2'>
                        <label>オプション</label>
                        <div className='md:grid md:grid-cols-2'>
                            <div>
                                <input type="checkbox" className="m-2 w-4 h-4 align-middle" id="missionCheck" checked={missionOptions[0]} onChange={(e) => changeMissionOptionsSelect(e, 0)} />
                                <label htmlFor='missionCheck' className='align-middle'>逃走チーム提出不可</label>
                            </div>
                            <div>
                                <input type="checkbox" className="m-2 w-4 h-4 align-middle" id="missionCheck2" checked={missionOptions[1]} onChange={(e) => changeMissionOptionsSelect(e, 1)} />
                                <label htmlFor='missionCheck2' className='align-middle'>鬼チーム提出不可</label>
                            </div>
                            <div>
                                <input type="checkbox" className="m-2 w-4 h-4 align-middle" id="missionCheck3" checked={missionOptions[2]} onChange={(e) => changeMissionOptionsSelect(e, 2)} />
                                <label htmlFor='missionCheck3' className='align-middle'>自動で繰り返し発令</label>
                                <div className={'mx-3 ' + (missionOptions[2] ? 'block' : 'hidden')}>
                                    <label className='text-sm'>繰り返し周期 [分]</label>
                                    <input type="number" min={1} value={missionRepeatInterval} onChange={(e) => setMissionRepeatInterval(e.target.value)} className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300" />
                                </div>
                            </div>
                            <div>
                                <input type="checkbox" className="m-2 w-4 h-4 align-middle" id="missionCheck4" checked={missionOptions[3]} onChange={(e) => changeMissionOptionsSelect(e, 3)} />
                                <label htmlFor='missionCheck4' className='align-middle'>位置情報必須</label>
                            </div>
                            <div>
                                <input type="checkbox" className="m-2 w-4 h-4 align-middle" id="missionCheck5" checked={missionOptions[4]} onChange={(e) => changeMissionOptionsSelect(e, 4)} />
                                <label htmlFor='missionCheck5' className='align-middle'>画像必須</label>
                            </div>
                            <div>
                                <input type="checkbox" className="m-2 w-4 h-4 align-middle" id="missionCheck6" checked={missionOptions[5]} onChange={(e) => changeMissionOptionsSelect(e, 5)} />
                                <label htmlFor='missionCheck6' className='align-middle'>コメント必須</label>
                            </div>
                            <div>
                                <input type="checkbox" className="m-2 w-4 h-4 align-middle" id="missionCheck7" checked={missionOptions[6]} onChange={(e) => changeMissionOptionsSelect(e, 6)} />
                                <label htmlFor='missionCheck7' className='align-middle'>QRコード必須</label>
                            </div>
                        </div>
                    </div>

                    {/* QRコードの設定 */}
                    {missionOptions[6] && (
                        <div className='mb-6 mx-2'>
                            <label>QRコード</label>
                            <input
                                value={missionQrCode}
                                onChange={(e) => setMissionQrCode(e.target.value)}
                                type="text"
                                className="w-full p-2 border rounded-lg mb-2 focus:outline-purple-300"
                                placeholder="QRコードに含まれるテキストを入力"
                            />
                            <p className='text-sm text-gray-500 mx-2'>参加者はこのテキストが含まれるQRコードを読み取るか、テキストを手動入力することでミッションを提出できます。</p>
                        </div>
                    )}

                    <div className='grid grid-cols-3'>
                        <button type='button' className='mx-2 border-red-500 border text-red-600 p-2 rounded-lg hover:bg-red-100' onClick={() => deleteMission(focusMission)}><i className='bi bi-trash me-2'></i>削除</button>
                        <button type='button' className='mx-2 col-span-2 bg-purple-500 text-white p-2 rounded-lg hover:bg-purple-700' onClick={() => addMission()}><i className='bi bi-check-lg me-2'></i>保存</button>
                    </div>
                </div>
            </div>

            {/* AI生成モーダル */}
            <CreateMissionAI
                isOpen={showAIModal}
                onClose={() => setShowAIModal(false)}
                onMissionGenerated={handleAIGeneratedMission}
                gameLocation={gameLocation}
                gameConcepts={gameConcepts}
            />
        </div>
    )
}

export default MissionsTab
